<template>
    <b-container fluid>
        <h3>{{ $t('SMSDienst') }}</h3>
        <table-responsive responsive ref="tableResponsive" :items="smsPinCodes" :field-definition="fields">
            <template v-slot:unsubscribe="data">
                <b-btn size="sm" @click.stop="stopSMS(data.item.ID)" v-if="data.item.unsubscribe === 'x'">{{ $t('SMSAbmelden') }}</b-btn>
                <span v-if="data.item.unsubscribe !== 'x'">{{ data.item.unsubscribe }}</span>
            </template>
        </table-responsive>
        <p>{{ $t('FrmProfil_SMS_Text') }}</p>
    </b-container>
</template>

<script>
import TableResponsive from "../components/tableResponsive.vue";
import moment from "moment"


export default {
    name: "smsPinCodes",
    data() {
        return {
            fields: [
                { key: 'mobile', label: 'Mobile' },
                { key: 'PIN', label: this.$t('SMSPinCode') },
                { key: 'instance', label: this.$t('Dienst') },
                { key: 'service', label: 'Keyword' },
                { key: 'operator', label: 'Operator' },
                { key: 'subscribed', label: this.$t('Angemeldet') },
                { key: 'lastSMS', label: this.$t('LetztesSMS'), formatter: (value) => { return (value.length > 0) ? moment(value).format("DD.MM.YYYY HH:mm:ss") : '' } },
                { key: 'subscribedOn', label: this.$t('Anmeldung'), formatter: (value) => { return (value.length > 0) ? moment(value).format("DD.MM.YYYY") : '' } },
                { key: 'unsubscribe', label: this.$t('Abmeldung') },
            ],
        };
    },
    computed: {
        smsPinCodes() {
            return this.$store.state.userStore.smsSubs
        }
    },
    methods: {
        stopSMS(id) {
            this.$store.dispatch("stopSMS", id)
        },
    },
    components: {
        "table-responsive": TableResponsive
    },
    created() {
        let self = this
        this.$nextTick(async function() {
            self.$store.dispatch("loadSMSSubs")
        });
        //window.addEventListener("resize", this.$refs["tableResponsive"].responsiveRefresh)
    },
    mounted() {},
    updated() {},
};
</script>

<style scoped>
    .active{
        font-weight: bold;
    }
</style>